<template>
  <div class="modal-box assemblychecklist-modal">
    <div class="modal-title">
      <h3>Montagechecklist</h3>
      <div class="flex-divider"></div>
      <base-button
        type="secondary"
        @click="printAssemblyChecklist"
      >
        <base-icon iconRef="printer" />
      </base-button>
      <base-button
        type="secondary"
        @click="closeModal"
      >
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content assemblychecklist-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h5>Klantnaam - Projectnaam - Adres</h5>
        </div>
        <p class="value">{{currentClient.data().clientName}} - {{currentProject.data().projectName}} - {{currentProject.data().address.street}} {{currentProject.data().address.houseNumber}}, {{currentProject.data().address.postCode}} {{currentProject.data().address.city}}</p>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Aflevering</h4>
        </div>
        <div class="input-container">
          <label class="label">Toegang:</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.entrance"
              native-value="Enkele deur"
              type="is-primary"
            >
              <span>Enkele deur</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.entrance"
              native-value="Dubbele deur/roldeur"
              type="is-primary"
            >
              <span>Dubbele deur/roldeur</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Lift aanwezig waar producten in passen?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.elevator"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.elevator"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Kunnen goederen eerder worden geleverd?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.earlyProductDelivery"
              native-value="Ja, opslag aanwezig"
              type="is-success"
            >
              <span>Ja, opslag aanwezig</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.earlyProductDelivery"
              native-value="Nee, levering op montagedag"
              type="is-danger"
            >
              <span>Nee, levering op montagedag</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-header">
          <h4>Montage</h4>
        </div>
        <div class="input-container">
          <label class="label">Montage door Rivasono?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.assemblyByRS"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.assemblyByRS"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div
          class="input-container"
          v-show="assemblyChecklist.assemblyByRS == 'Ja'"
        >
          <label class="label">Foto's gemaakt?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.pictures"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.pictures"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div
          class="input-container"
          v-show="assemblyChecklist.assemblyByRS == 'Ja'"
        >
          <label class="label">Plattegrond schets aanwezig?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.groundPlan"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.groundPlan"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Opmerking montage:</label>
          <span
            v-show="false"
            class="input description-value"
          >
            {{assemblyChecklist.description}}
          </span>
          <textarea
            class="input textarea"
            rows="3"
            placeholder=""
            v-model="assemblyChecklist.description"
          ></textarea>
        </div>
      </div>
      <div
        class="modal-content-section"
        v-show="assemblyChecklist.assemblyByRS == 'Ja'"
      >
        <div class="input-header">
          <h4>Wand</h4>
        </div>
        <div class="input-container">
          <label class="label">Soort wand:</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.wallType"
              native-value="Beton"
              type="is-primary"
            >
              <span>Beton</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.wallType"
              native-value="Gips"
              type="is-primary"
            >
              <span>Gips</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.wallType"
              native-value="Hout"
              type="is-primary"
            >
              <span>Hout</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.wallType"
              native-value="Staal"
              type="is-primary"
            >
              <span>Staal</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.wallType"
              native-value="Anders"
              type="is-primary"
            >
              <span>Anders</span>
            </b-radio-button>
          </b-field>
          <div
            class="input-container"
            v-if="assemblyChecklist.wallType == 'Anders'"
          >
            <label class="label">Namelijk:</label>
            <input
              type="text"
              name="wallTypeOther"
              id="wallTypeOther"
              class="input radio-other-input"
              v-model="assemblyChecklist.wallTypeOther"
            >
          </div>
        </div>
        <div class="input-header">
          <h5>Wandpanelen</h5>
        </div>
        <div class="input-container">
          <label class="label">Soort montage:</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.wallAssembly"
              native-value="Vlak op de wand"
              type="is-primary"
            >
              <span>Vlak op de wand</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.wallAssembly"
              native-value="Met airgap"
              type="is-primary"
            >
              <span>Met airgap</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-header">
          <h5>Wall panel system</h5>
        </div>
        <div class="input-container">
          <label class="label">Stopcontacten doorvoeren?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.outlets"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.outlets"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Montage tot aan de vloer, of boven bestaande plint?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.baseboard"
              native-value="Tot aan de vloer"
              type="is-primary"
            >
              <span>Op plint</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.baseboard"
              native-value="Boven bestaande plint"
              type="is-primary"
            >
              <span>Boven plint</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Kopse kant afwerken met L-profiel?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.lProfile"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.lProfile"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Gewenste kleur L-profiel:</label>
          <input
            type="text"
            name="lProfileColor"
            id="lProfileColor"
            v-model="assemblyChecklist.lProfileColor"
            class="input radio-other-input"
          >
        </div>
      </div>
      <div
        class="modal-content-section"
        v-show="assemblyChecklist.assemblyByRS == 'Ja'"
      >
        <div class="input-header">
          <h4>Plafond</h4>
        </div>
        <div class="input-container">
          <label class="label">Soort plafond:</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Beton"
              type="is-primary"
            >
              <span>Beton</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Gips"
              type="is-primary"
            >
              <span>Gips</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Stro/stuc"
              type="is-primary"
            >
              <span>Stro/stuc</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Staal"
              type="is-primary"
            >
              <span>Staal</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Hout"
              type="is-primary"
            >
              <span>Hout</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.ceilingType"
              native-value="Anders"
              type="is-primary"
            >
              <span>Anders</span>
            </b-radio-button>
          </b-field>
          <div
            class="input-container"
            v-if="assemblyChecklist.ceilingType == 'Anders'"
          >
            <label class="label">Namelijk:</label>
            <input
              type="text"
              name="ceilingTypeOther"
              id="ceilingTypeOther"
              class="input radio-other-input"
              v-model="assemblyChecklist.ceilingTypeOther"
            >
          </div>
        </div>
        <div class="input-container">
          <label class="label">Steiger nodig?</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.scaffolding"
              native-value="Ja"
              type="is-success"
            >
              <span>Ja</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.scaffolding"
              native-value="Nee"
              type="is-danger"
            >
              <span>Nee</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="input-container">
          <label class="label">Lampen:</label>
          <b-field>
            <b-radio-button
              v-model="assemblyChecklist.lights"
              native-value="Niet aanwezig"
              type="is-primary"
            >
              <span>Niet aanwezig</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.lights"
              native-value="Doorvoeren"
              type="is-primary"
            >
              <span>Doorvoeren</span>
            </b-radio-button>
            <b-radio-button
              v-model="assemblyChecklist.lights"
              native-value="Omheen werken"
              type="is-primary"
            >
              <span>Doorvoeren</span>
            </b-radio-button>
          </b-field>
        </div>
      </div>
      <div
        class="modal-content-section"
        v-show="assemblyChecklist.assemblyByRS == 'Ja'"
      >
        <div class="input-header">
          <h4>Ruimtes</h4>
        </div>
        <div
          v-for="(room, index) in currentProjectRooms"
          :key="index"
        >
          <div class="input-header value-header">
            <h5>{{room.data().roomName}}</h5>
          </div>
          <div class="input-container">
            <label class="label">Plafondhoogte</label>
            <div class="value">{{room.data().height}} m</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-divider"></div>
      <base-button
        @click="closeModal"
        type="secondary"
      >Annuleren</base-button>
      <base-button
        @click="saveAssemblyChecklist"
        :loading="savingAssemblyChecklist"
        :disabled="savingAssemblyChecklist"
      >
        <base-icon
          iconRef="checkmark"
          position="left"
        />Opslaan
      </base-button>
    </div>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      savingAssemblyChecklist: false,
      assemblyChecklist: {
        entrance: "",
        elevator: "",
        elevatorFit: "",
        pictures: "",
        groundPlan: "",
        assemblyByRS: "",
        description: "",
        lProfile: "",
        lProfileColor: "",
        earlyProductDelivery: "",
        ceilingHeight: "",
        ceilingType: "",
        lights: "",
        scaffolding: "",
        wallType: "",
        wallTypeOther: "",
        wallAssembly: "",
        outlets: "",
        baseboard: ""
      }
    };
  },
  computed: {
    currentClient() {
      return this.$store.getters.getCurrentClientPage.client;
    },
    currentProject: function() {
      return this.$store.getters.getCurrentClientPage.project;
    },
    currentProjectRooms: function() {
      return this.$store.getters.getRoomsList.filter(room => {
        return (
          room.data().belongsTo == this.currentProject.id &&
          room.data().trashed == false
        );
      });
    }
  },
  methods: {
    printAssemblyChecklist() {
      window.print();
    },
    saveAssemblyChecklist() {
      this.savingAssemblyChecklist = true;
      Firebase.firestore()
        .collection("projects")
        .doc(this.currentProject.id)
        .set(
          {
            assemblyChecklist: this.assemblyChecklist
          },
          { merge: true }
        )
        .then(() => {
          this.$store.dispatch("fetchProjects").then(() => {
            this.savingAssemblyChecklist = false;
            this.closeModal();
          });
        })
        .catch(error => {
          console.log("Error saving assemblyChecklist: ", error);
        });
    },
    closeModal() {
      this.$store.commit("setModalShown", {
        dataType: "assemblyChecklist",
        modalType: "view",
        shown: false
      });
    }
  },
  mounted() {
    this.assemblyChecklist = Object.assign(
      {},
      this.currentProject.data().assemblyChecklist
    );
  }
};
</script>


// WEBPACK FOOTER //
// src/components/modal-components/assemblychecklist-view-modal.vue